import { uniq } from 'lodash';
import { useMemo } from 'react';
import { useEventSchedule } from '../schedule/useEventSchedule';
import { useLiveVotingSessions } from './useLiveVotingSessions';

/**
 * Selects live voting sessions connected to the program (joined by session_content_url)
 * @param  {[type]} eventId   [description]
 * @param  {[type]} programId [description]
 * @return {[type]}           [description]
 */
export function useProgramLiveVoting(eventId, programId) {
    const sessions = useEventSchedule(eventId),
        programItem = useMemo(() => sessions.find((session) => session.id == programId), [(sessions, programId)]),
        votingSessions = useLiveVotingSessions(eventId);

    return useMemo(() => {
        const votingSessions = [programItem?.vote_id];

        if (programItem?.session_content_url) {
            for (let session of sessions) {
                if (session.session_content_url == programItem.session_content_url) {
                    votingSessions.push(session.vote_id);
                }
            }
        }

        return uniq(votingSessions.filter((i) => i).map((id) => votingSessions.find((session) => session.id == id)));
    }, [programItem, sessions, votingSessions]);
}
